import $ from 'jquery';

const initAnimateImagesStack = (el) => {
  const $this = $(el);
  const $archived = $(el).parents('.artist--archive');

  if ($archived.length) {
    return;
  }

  const primaryImage = $this.children('.images-stack__image--primary')[0];

  $this.on('mouseover', () => {
    $(primaryImage).addClass('hovered');
  });

  $this.on('mouseleave', () => {
    $(primaryImage).removeClass('hovered').addClass('animated');
    $(primaryImage).on('animationend', () => $(primaryImage).removeClass('animated'));
  });
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstAnimateImagesStack = {
    attach(context) {
      $('.images-stack', context).each((index, element) => initAnimateImagesStack(element));
    },
  };
}(window, Drupal));
